import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './ContactosUteis.css';

const ContactosUteis = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [contactos, setContactos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [grupoAtivo, setGrupoAtivo] = useState(null); // null = ecrã de grupos
    const [pesquisa, setPesquisa] = useState('');

    useEffect(() => {
        fetchContactos();
    }, []);

    const fetchContactos = async () => {
        try {
            const res = await api.get('/contactos-uteis', { params: { _t: Date.now() } });
            setContactos(res.data);
        } catch (err) {
            console.error('Erro ao carregar contactos:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        if (user?.perfil_mobile) navigate('/mobile-dashboard');
        else navigate(-1);
    };

    const handleCall = (telefone) => {
        if (telefone) window.location.href = `tel:${telefone.replace(/\s/g, '')}`;
    };
    const handleEmail = (email) => {
        if (email) window.location.href = `mailto:${email}`;
    };
    const handleMapa = (c) => {
        const q = encodeURIComponent([c.morada, c.codigo_postal, c.localidade].filter(Boolean).join(', '));
        if (q) window.open(`https://maps.google.com/?q=${q}`, '_blank');
    };

    const grupos = [...new Set(contactos.map(c => c.grupo || 'Geral'))].sort();

    // Sem grupo escolhido, a pesquisa é global (todos os grupos)
    let visiveis = grupoAtivo ? contactos.filter(c => (c.grupo || 'Geral') === grupoAtivo) : contactos;
    if (pesquisa.trim()) {
        const t = pesquisa.trim().toLowerCase();
        visiveis = visiveis.filter(c =>
            (c.nome || '').toLowerCase().includes(t) || (c.referencia || '').toLowerCase().includes(t) ||
            (c.localidade || '').toLowerCase().includes(t) || (c.concelho || '').toLowerCase().includes(t) ||
            (c.morada || '').toLowerCase().includes(t));
    }
    const limitado = visiveis.length > 100;
    const mostrar = limitado ? visiveis.slice(0, 100) : visiveis;

    const renderContacto = (c) => (
        <div key={c.id} className="cu-card">
            <div className="cu-avatar">
                {(c.nome || '?').charAt(0).toUpperCase()}
            </div>
            <div className="cu-info">
                <span className="cu-nome">{c.referencia ? `${c.referencia} — ` : ''}{c.nome}</span>
                {!grupoAtivo && <span className="cu-cargo" style={{ fontSize: 11, color: '#2b6cb0', fontWeight: 700 }}>{c.grupo || 'Geral'}</span>}
                {c.cargo && <span className="cu-cargo">{c.cargo}</span>}
                {(c.morada || c.localidade) && (
                    <span className="cu-cargo" style={{ fontSize: 12 }}>
                        📍 {[c.morada, c.codigo_postal, c.localidade || c.concelho].filter(Boolean).join(' · ')}
                    </span>
                )}
                {c.telefone && <span className="cu-telefone">{c.telefone}</span>}
                {c.email && <span className="cu-email">{c.email}</span>}
            </div>
            <div className="cu-actions">
                {c.telefone && (
                    <button className="cu-btn-call" onClick={() => handleCall(c.telefone)} title="Ligar">📞</button>
                )}
                {c.email && (
                    <button className="cu-btn-email" onClick={() => handleEmail(c.email)} title="Email">✉️</button>
                )}
                {(c.morada || c.localidade) && (
                    <button className="cu-btn-email" onClick={() => handleMapa(c)} title="Abrir no mapa">🗺️</button>
                )}
            </div>
        </div>
    );

    if (loading) {
        return (
            <div className="contactos-page">
                <div className="cu-header">
                    <button className="cu-back-btn" onClick={handleBack}>← Voltar</button>
                    <h1>Contactos Úteis</h1>
                </div>
                <div className="cu-loading">A carregar...</div>
            </div>
        );
    }

    // Ecrã 1: grupos
    if (!grupoAtivo) {
        return (
            <div className="contactos-page">
                <div className="cu-header">
                    <button className="cu-back-btn" onClick={handleBack}>← Voltar</button>
                    <h1>📞 Contactos Úteis</h1>
                </div>
                <div style={{ padding: '0 16px 8px' }}>
                    <input
                        value={pesquisa}
                        onChange={e => setPesquisa(e.target.value)}
                        placeholder="🔎 Pesquisar em todos os grupos…"
                        style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #cbd5e0', fontSize: 15, boxSizing: 'border-box' }}
                    />
                </div>
                {pesquisa.trim() ? (
                    <div className="cu-list">
                        {mostrar.length === 0 ? (
                            <div className="cu-empty"><p>Nenhum contacto encontrado.</p></div>
                        ) : mostrar.map(renderContacto)}
                        {limitado && (
                            <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '10px 0' }}>
                                A mostrar 100 de {visiveis.length} — refine a pesquisa.
                            </div>
                        )}
                    </div>
                ) : (
                <div style={{ padding: '8px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {grupos.length === 0 && (
                        <div className="cu-empty">
                            <p>Nenhum contacto disponível.</p>
                            <p className="cu-empty-hint">Os contactos são geridos pelo administrador em Configurações.</p>
                        </div>
                    )}
                    {grupos.map(g => {
                        const n = contactos.filter(c => (c.grupo || 'Geral') === g).length;
                        return (
                            <button key={g} onClick={() => { setGrupoAtivo(g); setPesquisa(''); }}
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    padding: '18px 16px', borderRadius: 12, border: 'none', cursor: 'pointer',
                                    background: 'linear-gradient(135deg, #2b6cb0, #3182ce)', color: '#fff',
                                    fontSize: 17, fontWeight: 700, boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                }}>
                                <span>{g === 'GALP' ? '⛽' : '📇'} {g}</span>
                                <span style={{ fontSize: 13, fontWeight: 600, background: 'rgba(255,255,255,0.25)', borderRadius: 12, padding: '4px 10px' }}>
                                    {n} contacto{n === 1 ? '' : 's'} ›
                                </span>
                            </button>
                        );
                    })}
                </div>
                )}
            </div>
        );
    }

    // Ecrã 2: contactos do grupo
    return (
        <div className="contactos-page">
            <div className="cu-header">
                <button className="cu-back-btn" onClick={() => { setGrupoAtivo(null); setPesquisa(''); }}>← Grupos</button>
                <h1>{grupoAtivo === 'GALP' ? '⛽' : '📇'} {grupoAtivo}</h1>
            </div>

            <div style={{ padding: '0 16px 8px' }}>
                <input
                    value={pesquisa}
                    onChange={e => setPesquisa(e.target.value)}
                    placeholder="🔎 Pesquisar nome, ID, localidade…"
                    style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #cbd5e0', fontSize: 15, boxSizing: 'border-box' }}
                />
            </div>

            <div className="cu-list">
                {mostrar.length === 0 ? (
                    <div className="cu-empty">
                        <p>Nenhum contacto encontrado.</p>
                        <p className="cu-empty-hint">Os contactos são geridos pelo administrador em Configurações.</p>
                    </div>
                ) : (
                    mostrar.map(renderContacto)
                )}
                {limitado && (
                    <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '10px 0' }}>
                        A mostrar 100 de {visiveis.length} — refine a pesquisa.
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContactosUteis;
